import React from 'react';
import Home from '../pages/home';
import Loading from '../components/Loading';
import EmpDetails from '../pages/employee-details';
import CustomerDetails from '../pages/customer-details';
import OfficeDetails from '../pages/office-details';
import CrmDeals from '../pages/crm-deals.js';
import CrmActiveDeals from '../pages/crm-active-deals.js';
import CrmDealDetails from '../pages/crm-deal-details';
import CrmOrganizations from '../pages/crm-organizations';
import CrmOrganizationDetails from '../pages/crm-organization-details';
import CrmPersons from '../pages/crm-persons';
import CrmPersonDetails from '../pages/crm-person-details';
import CrmActivities from '../pages/crm-activities';
import CrmInputDemo from './crm/shared/field_inputs/demo/CrmInputDemo';
import Logs from '../pages/logs';
import { useRedirect } from 'hookrouter';
import CrmPage from '../pages/crm-page';
import CrmInsights from '../pages/crm-insights';
import ExlCourses from '../pages/exl-courses';
import ExlTeachers from '../pages/exl-teachers';
import ExlPage from '../pages/exl-page';
import ExlCourseDetails from '../pages/exl/course-details/course-details';
import TeacherDetails from '../pages/exl/teacher-details/teacher-details';
// import ExlCourseDetails from '../pages/exl-course-details';
import CourseInvite from '../components/exl/CourseInvite';
import ExlTeacherDetails from '../pages/exl-teacher-details';
import ExlLectureDetails from '../pages/exl/lecture-details/lecture-details';

export const Routes = {
    ///TABLES
    '/': () => <Home />,
    '/employees': () => <Home />,
    '/customers': () => <Home />,
    '/offices': () => <Home />,
    '/offices/internalhours': () => <Home />,
    '/coverings': () => <Home />,

    '/employee/:id/info': ({ id }) => <EmpDetails empId={id} />,
    '/employee/:id/billing': ({ id }) => <EmpDetails empId={id} />,
    '/employee/:id/hours': ({ id }) => <EmpDetails empId={id} />,
    '/employee/:id/courses': ({ id }) => <EmpDetails empId={id} />,
    '/employee/:id/certificates': ({ id }) => <EmpDetails empId={id} />,

    '/account/signout': () => <Loading />,
    '/customer/:id': ({ id }) => <CustomerDetails customerId={id} />,
    '/office/:id': ({ id }) => <OfficeDetails officeId={id} />,
    '/logs': () => <Logs />,
    '/crmDeals': () => (
        <CrmPage pageName={'CrmDeals'}>
            <CrmDeals pipelineId='00000001-0000-0000-0000-000000000000' />
        </CrmPage>
    ),
    '/crmActiveDeals': () => (
        <CrmPage pageName={'CrmActiveDeals'}>
            <CrmActiveDeals />
        </CrmPage>
    ),
    '/crmDealDetails/:id': ({ id }) => (
        <CrmPage pageName={'CrmDealDetails'}>
            <CrmDealDetails id={ensureValidGuid(id)} />
        </CrmPage>
    ),
    '/crmOrganizations': () => (
        <CrmPage pageName={'CrmOrganizations'}>
            <CrmOrganizations />
        </CrmPage>
    ),
    '/crmOrganizationDetails/:id': ({ id }) => (
        <CrmPage pageName={'CrmOrganizationDetails'}>
            <CrmOrganizationDetails id={ensureValidGuid(id)} />
        </CrmPage>
    ),
    '/crmPersons': () => (
        <CrmPage pageName={'CrmPersons'}>
            <CrmPersons />
        </CrmPage>
    ),
    '/crmPersonDetails/:id': ({ id }) => (
        <CrmPage pageName={'CrmPersonDetails'}>
            <CrmPersonDetails id={ensureValidGuid(id)} />
        </CrmPage>
    ),
    '/crmActivities': () => (
        <CrmPage pageName={'CrmActivities'}>
            <CrmActivities />
        </CrmPage>
    ),
    '/crm/inputdemo': () => (
        <CrmPage>
            <CrmInputDemo />
        </CrmPage>
    ),
    '/crmAvailableConsultants': () => (
        <CrmPage pageName={'CrmAvailableConsultants'}>
            <CrmDeals pipelineId='00000002-0000-0000-0000-000000000000' />
        </CrmPage>
    ),
    '/crmInsights': () => (
        <CrmPage pageName={'CrmInsights'}>
            <CrmInsights />
        </CrmPage>
    ),
    '/exlCourses': () => (
        <ExlPage pageName={'ExlCourses'}>
            <ExlCourses />
        </ExlPage>
    ),
    '/exlTeachers': () => (
        <ExlPage pageName={'ExlTeachers'}>
            <ExlTeachers />
        </ExlPage>
    ),
    '/exlCourseDetails/:id': ({ id }) => (
        <ExlPage pageName={'ExlCourseDetails'}>
            <ExlCourseDetails id={ensureValidGuid(id)} />
        </ExlPage>
    ),
    '/exlCourseInvite': () => (
        <ExlPage pageName={'ExlCourseInvite'} >
            HELLO WORLD
        </ExlPage>
    ),
    '/exlTeacherDetails/:id': ({ id }) => (
        <ExlPage pageName={'ExlTeacherDetails'} >
            <TeacherDetails id={ensureValidGuid(id)} />
        </ExlPage>
    ),
    '/exlLectureDetails/:id': ({ id }) => (
        <ExlPage pageName={'ExlLectureDetails'} >
            <ExlLectureDetails id={ensureValidGuid(id)} />
        </ExlPage>
    ),
};

export const ExternalRoutes = {
    '/exlCourseInvite/:id': ({ id }) => <CourseInvite courseId={id} />,
};

function ensureValidGuid(id) {
    if (id && id.toString) {
        id = id.toString().toLowerCase();
    }
    return id;
}

const commonRedirects = () => {
    CrmPagesRedirect();
    CrmActiveDealsRedirect();
    CrmAvailableConsultantsPagesRedirect();
    CrmInsightsPagesRedirect();
    CrmDealDetailsPagesRedirect();
    CrmOrganizationsPagesRedirect();
    CrmOrganizationDetailsPagesRedirect();
    CrmPersonsPagesRedirect();
    CrmPersonDetailsPagesRedirect();
    CrmActivitiesPagesRedirect();
};

export const AddRedirects = (user) => {
    useRedirect('/Employee/GetEmployees', '/employees');
    useRedirect('/', '/employees');
    useRedirect('/index.html', '/employees');

    if (!user || user.isAdmin) {
        return;
    }

    if (user.isEcoOrSales || user.isOfficeBoss) {
        if (!user.isCrmUser) {
            commonRedirects();
        }
    } else if (user.isRecruiter || user.isMgr) {
        commonRedirects();
        AddCustomerPagesRedirects();
        AddOfficePagesRedirects();
    } else {
        commonRedirects();
        AddCustomerPagesRedirects();
        AddOfficePagesRedirects();
        AddCoveringPagesRedirects();
    }
};


const AddCustomerPagesRedirects = () => {
    const error = { status: 401 };

    useRedirect('/customers', '/error', error);
};

const AddOfficePagesRedirects = () => {
    const error = { status: 401 };

    useRedirect('/offices/internalhours', '/error', error);
};

const AddCoveringPagesRedirects = () => {
    const error = { status: 401 };

    useRedirect('/coverings', '/error', error);
};

const CrmPagesRedirect = () => {
    const error = { status: 401 };

    useRedirect('/crmDeals', '/error', error);
};

const CrmActiveDealsRedirect = () => {
    const error = { status: 401 };

    useRedirect('/crmActiveDeals', '/error', error);
};

const CrmAvailableConsultantsPagesRedirect = () => {
    const error = { status: 401 };

    useRedirect('/crmAvailableConsultants', '/error', error);
};

const CrmInsightsPagesRedirect = () => {
    const error = { status: 401 };

    useRedirect('/crmInsights', '/error', error);
};

const CrmDealDetailsPagesRedirect = () => {
    const error = { status: 401 };

    useRedirect('/crmDealDetails', '/error', error);
};

const CrmOrganizationsPagesRedirect = () => {
    const error = { status: 401 };

    useRedirect('/crmOrganizations', '/error', error);
};

const CrmOrganizationDetailsPagesRedirect = () => {
    const error = { status: 401 };

    useRedirect('/crmOrganizationDetails', '/error', error);
};

const CrmPersonsPagesRedirect = () => {
    const error = { status: 401 };

    useRedirect('/crmPersons', '/error', error);
};

const CrmPersonDetailsPagesRedirect = () => {
    const error = { status: 401 };

    useRedirect('/crmPersonDetails', '/error', error);
};

const CrmActivitiesPagesRedirect = () => {
    const error = { status: 401 };

    useRedirect('/crmActivities', '/error', error);
};
